import * as React from 'react';
import { ModalConsumer } from '../Contexts/ModalContext';

const ModalRoot = () => (
  <ModalConsumer>
    {({ component: Component, props, hideModal }) =>
      Component ? <Component {...props} onRequestClose={props.onRequestClose || hideModal} /> : null
    }
  </ModalConsumer>
);

export default ModalRoot;
